
import { Component, Prop, Vue } from 'vue-property-decorator';
import { purchaseList } from '@/collections/purchase_list';
import { EventBus } from '@/eventBus';
import type { PurchaseListItemInput } from '@/types/purchase-list';

@Component({})
export default class AddToPurchaseListButton extends Vue {
  @Prop({ required: true }) public readonly item!: PurchaseListItemInput;

  public busy = false;
  public added = false;

  public async add(): Promise<void> {
    if (this.added || this.busy) { return; }
    this.busy = true;
    try {
      await purchaseList.addItem(this.item);
      this.added = true;
      this.$emit('added');
      EventBus.$emit('show-snackbar', {
        message: `Added ${this.item.productName} to purchase list`,
        color: 'success',
        action: { label: 'View Purchase List', to: '/purchase-orders/purchase-list/review' },
      });
    } catch (e) {
      EventBus.$emit('show-snackbar', { message: 'Failed to add to purchase list', color: 'error' });
    } finally {
      this.busy = false;
    }
  }
}
